export default "__VITE_ASSET__BuNkaGGG__"